import script from "./multi-brand-and-multi-product-promotions.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-brand-and-multi-product-promotions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__